export default __webpack_public_path__ + "static/left-veigar-cefe43ba445ffc5350f7a9739f88f01f.png";